// ******************** LAST EDIT - 2/17/22 ************************************

import aspect = require("dojo/aspect");

import Directions = require("esri/widgets/Directions");
import Collection = require("esri/core/Collection");
import { subclass } from "esri/core/accessorSupport/decorators";
import { tsx } from "esri/widgets/support/widget";
// @ts-ignore
import { on as reactOn, watch } from "esri/core/reactiveUtils";
// @ts-ignore
import { pausable } from "esri/core/events";

const REGISTRY_KEYS = {
  awaitingViewClickStop: "awaiting-view-click-stop"
};

const searchTermHandle = "search-term";

@subclass("app.route.core.Directions")
export default class CustomDirections extends Directions {

  indoorsContext = null;
  indoorsHandles = [];
  indoorsRouteServiceUrl = null;
  steps = null;
  tsUtil;
  isQuerying = false;

  constructor(params,parentNode) {
    // @ts-ignore
    super(params,parentNode);
    this.indoorsContext = params.indoorsContext;
    this.indoorsRouteServiceUrl = params.indoorsRouteServiceUrl;
    this.tsUtil = params.tsUtil;
    const lib = this.indoorsContext.lib;
    // @ts-ignore
    this._autoStopRemovalDelay = 1500; // TODO this no longer works at 4.17
    this.steps = new lib.indoors.Steps({
      directionsWidget: this,
      indoorsContext: this.indoorsContext,
      tsUtil: this.tsUtil
    });
    this.indoorsInit(params?.view);
    this._setStopSymbols();
  }

  acquireSearch(stop) {
    const view = this.viewModel.view;

    // @ts-ignore
    if (this._stopsToSearches.has(stop)) {
      // @ts-ignore
      const search = this._stopsToSearches.get(stop);
      search.view = view;
      // @ts-ignore
      this._overrideDefaultSources(search);
      return search;
    }

    const lib = this.indoorsContext.lib;
    const search = new lib.indoors.CustomSearch({
      indoorsDirections: this,
      indoorsContext: this.indoorsContext,
      tsUtil: this.tsUtil,
      view,
      resultGraphicEnabled: false,
      popupEnabled: false,
      mainSearchbox: false,
      ...this.searchProperties
    });

    // @ts-ignore
    this._normalizeSearchSources(search);

    // @ts-ignore
    this.addHandles(
      [
        // @ts-ignore
        reactOn(() => search.allSources,"change",() => this._normalizeSearchSources(search)),
        search.on("select-result", (event) => {
          const source = this.indoorsContext.aiim.datasets && this.indoorsContext.aiim.datasets.categories.findSourceByKey(event.source.aiimKey);
          if (source) {
            if (source.isPeopleLayer()) {
              this.indoorsOnPersonSelected(source, event.result, search, stop);
            } else {
              this._setStop(search, stop);
            }
          } else {
            stop.geometry = search.selectedResult.feature.geometry ;
            stop.name = search.selectedResult.name;
          }
          // this.getDirections();
        }),
        // @ts-ignore
        search.on("search-focus", () => {
          // @ts-ignore
          this._handleStopInputFocus(search, stop)
          // @ts-ignore
          this._activeStop = stop; // core issue 4.25
        }),
        // @ts-ignore
        search.on("search-blur", () => {
          this._handleStopInputBlur(search, stop)
        }),
        search.on("search-clear", () => {
          stop.geometry = null;
          stop.name = null;
          
          // @ts-ignore
          this._activeStop = stop;

          // @ts-ignore
          const stops = this.viewModel.layer.stops;
          if (stops) {
            const hasGeom = stops.some(st => !!st.geometry);
            if (!hasGeom) {
              // @ts-ignore
              this.viewModel.indoorsRemoveResult();
              this.scheduleRender();
            }
          }
        }),
        watch(
          () => search.searchTerm,
          (searchTerm) => {
            stop.name = searchTerm;
          }
        )
      ],
      search
    );

    if (stop && stop.result) {
      let f = stop.result.feature;
      let a = f && f.attributes;
      if (a && a.Name) {
        search.searchTerm = a.Name;
        search.viewModel._set("selectedResult", stop.result);
      }
    }

    // @ts-ignore
    this._stopsToSearches.set(stop, search);

    return search;
  }

  async getDirections() {
    this._setStopSymbols();
    const stopCount = this.viewModel.layer.stops.filter(({ geometry }) => geometry != null).length;
    if (stopCount < 2) return;
    // @ts-ignore
    return super.getDirections();
  }

  protected _handleStopInputBlur(search, stop): void {
    // @ts-ignore
    if (this._saveLayer.opened) {
      return;
    }
    // @ts-ignore
    this.removeHandles(searchTermHandle);

    const searchGeometry = search.selectedResult && search.selectedResult.feature.geometry;

    const unchanged =
      !!search.selectedResult &&
      stop.geometry != null &&
      search.selectedResult?.feature.geometry != null &&
      stop.geometry === search.selectedResult?.feature.geometry;

    if (unchanged) {
      // @ts-ignore
      this._pointerDownUpHandle.pause();
      return;
    }

    const noGeometry = stop.geometry == null && search.selectedResult?.feature.geometry == null;
    const differentGeometry =
      stop.geometry != null &&
      search.selectedResult?.feature.geometry != null &&
      stop.geometry !== search.selectedResult?.feature.geometry;

    if (noGeometry || differentGeometry) {
      if (search.activeMenu === "none" && search.searchTerm) {
        search.search();
        // @ts-ignore
        this._pointerDownUpHandle?.pause();
        return;
      }
    }

    if (!search.searchTerm) {
      // @ts-ignore
      this._viewClickHandle.resume();

      // @ts-ignore
      clearTimeout(this._autoStopRemovalTimeoutId);

      // *** Indoors
      let delay = 1500; // _autoStopRemovalDelay

      // @ts-ignore
      this._autoStopRemovalTimeoutId = setTimeout(() => {
        if (this.destroyed) {
          return;
        }

        // *** Indoors
        if (search.searchTerm) {
          // @ts-ignore
          this._pointerDownUpHandle.pause();
          return;
        }

        // @ts-ignore
        this._viewClickHandle.pause();

        if (search.viewModel.state === "searching") {
          // @ts-ignore
          this._pointerDownUpHandle.pause();
          return;
        }

        // @ts-ignore
        if (this._pointerPressedSearchSuggestionStop) {
          // blur caused by pointer down interaction, we'll wait for pointer up to decide whether to remove or not
          return;
        }

        if (stop.geometry != null) {
          stop.geometry = null;
          // @ts-ignore
          this._processStops();
        }

        this.scheduleRender();
      }, delay);
    }
  }

  _handleViewClick(event) {
    // @ts-ignore
    const input = this._stopsToSearches.get(this._activeStop);

    if (input && !input.searchTerm) {

      // *** Indoors - Issue #893
      event.stopPropagation();
      const mapPoint = event.mapPoint;

      this.tsUtil.hitTestSearch(this.view, event).then((hits) => {
        // console.log("aiim.hitTest",hits);
        if (hits && hits.length > 0) {
          const hit = hits[0];
          this.tsUtil.fixHitZ(hit);
          // @ts-ignore
          const stop = this._activeStop;
          // @ts-ignore
          const searchResult = Object.assign({},hit.searchResult);
          searchResult.feature = this._makeStopResultFeature(searchResult,stop);
          if (mapPoint) {
            const g = searchResult.feature.geometry;
            mapPoint.z = g.z;
            mapPoint.hasZ = g.hasZ;
            searchResult.feature.geometry = mapPoint;
            stop.geometry = mapPoint;
          }
          stop.result = searchResult;

          const i18n = this.indoorsContext.i18n;
          stop.result.feature.attributes.Name = hit.caption || i18n.general.untitled;
          input.searchTerm = hit.caption || i18n.general.untitled;

          input.viewModel._set("selectedResult", stop.result);

          // @ts-ignore
          this._processStops();
          this.scheduleRender();

          // @ts-ignore
          clearTimeout(this._autoStopRemovalTimeoutId);
        } else {
          if (mapPoint) {
            const i18n = this.indoorsContext.i18n;
            let caption = i18n.yourPlaces.droppedPin;
            // @ts-ignore
            const searchResult = {
              feature: {
                geometry: mapPoint
              },
              sourceIndex: 0,
              name: caption
            };
            // @ts-ignore
            const stop = this._activeStop;
            searchResult.feature = this._makeStopResultFeature(searchResult,stop);
            stop.result = searchResult;

            stop.result.feature.attributes.Name = caption || i18n.general.untitled;
            input.searchTerm = caption || i18n.general.untitled;

            input.viewModel._set("selectedResult", stop.result);

            // @ts-ignore
            this._processStops();
            this.scheduleRender();

            // @ts-ignore
            clearTimeout(this._autoStopRemovalTimeoutId);
          }
        }
      }).catch((ex) => {
        console.error("Mapclick error:",ex);
      });
      this.scheduleRender();

    } else {
      // @ts-ignore
      clearTimeout(this._autoStopRemovalTimeoutId);
    }

    // @ts-ignore
    this._viewClickHandle.pause();
  }

  // @ts-ignore
  _prepViewClick() {
    const view = this.viewModel.view;

    const viewUtil = this.tsUtil.getViewUtil();
    const viewClickHandle = viewUtil.watchForViewClick("directions", view, event => {
      event.stopPropagation();
      this._handleViewClick(event);
    });

    // @ts-ignore
    const surfaceClickHandle = pausable(view.surface, "click", () => {
      // @ts-ignore
      clearTimeout(this._autoStopRemovalTimeoutId);
      surfaceClickHandle.pause();
    });

    const indoorsContext = this.indoorsContext;
    let pauseTimeout = null;
    return {
      remove(): void {
        surfaceClickHandle.remove();
        viewClickHandle.remove();
        clearTimeout(pauseTimeout);
        if (indoorsContext && indoorsContext.views) {
          indoorsContext.views.toggleClickHandlers("resume");
        }
      },
      pause(): void {
        surfaceClickHandle.pause();
        viewClickHandle.pause();
        clearTimeout(pauseTimeout);
        if (indoorsContext && indoorsContext.views) {
          pauseTimeout = setTimeout(() => {
            indoorsContext.views.toggleClickHandlers("resume");
          }, 1500);
        }
      },
      resume(): void {
        surfaceClickHandle.resume();
        viewClickHandle.resume();
        clearTimeout(pauseTimeout);
        if (indoorsContext && indoorsContext.views) {
          indoorsContext.views.toggleClickHandlers("pause");
        }
      }
    };
  }

  protected _processStops(): void {
    this.getDirections()
  }

  _renderReadyContent(): any {
    return [
      // @ts-ignore
      this._renderStopsContainer(),
      // @ts-ignore
      this._renderTravelModeOptions(),
      this.steps.render(),
      // this._renderDepartureTimeControls(),
      // this._renderSectionSplitter(),
      // this._renderDirectionsContainer(),
      // this._renderDisclaimer()
    ];
  }

  protected _renderTravelModeOptions() {
    // @ts-ignore
    const routeResult = this.viewModel.indoorsRouteResult;
    const sections =  (routeResult && routeResult.sections);
    const hasSections = !!(sections && sections.length > 0);

    const startClicked = () => {
      // @ts-ignore
      const r = this.viewModel.indoorsRouteResult;
      if (r) {
        this.tsUtil.Topic.publish(this.tsUtil.Topic.ActivateNavigator, {
          routeResult: r
        });
      }
    };

    let startButton = null;
    if (hasSections) {
      const supportsNavigator = this.indoorsContext.uiMode.supportsNavigator();
      if (supportsNavigator) {
        const startIcon = (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3.35 23.956L12.35 0l9 23.956-9-5.956z"/></svg>
        );
        startButton = (
          <button key={"start"} class={"i-button i--navigator-start"}
            bind={this} onclick={startClicked} data-i-navigator-start-button="true">
            {startIcon}
            <span>{this.indoorsContext.i18n.general.go || "GO"}</span>
          </button>
        );
      }
    }

    let sel;
    const { travelModes } = this.viewModel;
    if (travelModes.length > 0) {
      const { selectedTravelMode: travelMode } = this.viewModel;
      // @ts-ignore
      const title = travelMode.name || this.messages.travelMode;
      const cls = "esri-directions__travel-modes-select esri-select";
      // @ts-ignore
      sel = (<select onchange={this._handleTravelModeChange}
          aria-label={title}
          bind={this}
          class={cls}
          key="esri-directions__travel-mode-options"
          title={title}
        >
          {travelModes.map((mode) => {
            const selected = mode.id === travelMode.id;
            return (
              <option key={mode as any} data-mode={mode} selected={selected} value={mode.id}>
                {mode.name}
              </option>
            );
          })}
        </select>
      );
    } else if (startButton) {
      sel = (<span key="empty"></span>);
    }

    let node = null;
    if (sel || startButton) {
      node = (
        <div key="tms" class="i-flex-between i-travel-mode">
          {sel}{startButton}
        </div>
      );
    }
    return node;
  }

  protected async _solveRoute(): Promise<void> {
    this._setStopSymbols();
    // @ts-ignore
    return super._solveRoute();
  }

  /* Indoors *************************************************************** */

  indoorsClearHandles() {
    this.indoorsHandles.forEach((h) => {
      try {
        h.remove();
      } catch (ex) {
        console.error("core/Directions - error removing handle:",ex);
      }
    });
    this.indoorsHandles = [];
  }

  indoorsInit(view) {
    const self = this;
    const lib = this.indoorsContext.lib;
    this.viewModel = new lib.indoors.CustomDirectionsViewModel({
      indoorsRouteServiceUrl: this.indoorsRouteServiceUrl,
      indoorsContext: this.indoorsContext,
      indoorsCustomDirections: this,
      tsUtil: this.tsUtil,
      view: view
    });

    this.indoorsHandles.push(aspect.after(this, "_handleStopInputFocus", function() {
      // *** Indoors - Issue #893
      // @ts-ignore
      this._viewClickHandle.resume();
    }));
    // this.indoorsHandles.push(aspect.after(this, "_handleStopInputBlur", function() {
    // }));
    this.indoorsHandles.push(aspect.after(this, "destroy", function() {
      self.indoorsClearHandles();
    }));
  }

  indoorsMyPlaceSelected(item) {
    let label, searchResult;
    if (item.isBluedot) {
      label = item.label;
      let graphic = this.indoorsContext.bluedot.graphic;
      if (graphic) {
        graphic = graphic.clone();
        graphic.attributes = {Name: label, bluedot: "y"};
        searchResult = {
          extent: null,
          feature: graphic,
          name: label,
          key: item.key,
          sourceIndex: 0  // TODO?
        };
      } else {
        return;
      }
    } else {
      label = item.getLabel();
      // @ts-ignore
      searchResult = Object.assign({},item.searchResult);
    }

    // @ts-ignore
    const input = this._stopsToSearches.get(this._activeStop);
    input.searchTerm = label;
    // @ts-ignore
    const stop = this._activeStop;
    searchResult.feature = this._makeStopResultFeature(searchResult,stop);
    stop.result = searchResult;
    stop.result.feature.attributes.Name = label; // TODO?
    searchResult.name = label;
    //console.log("indoorsMyPlaceSelected.stop.result",stop.result)
    input.viewModel._set("selectedResult", stop.result);
    // @ts-ignore
    this._processStops();
    this.scheduleRender();
  }

  //@ts-ignore
  indoorsOnPersonSelected = async (source: any, person: any, search: any, stop: any) => {
    if (this.isQuerying) return;
    try {
      this.isQuerying = true;
      await this._indoorsOnPersonSelected(source, person, search, stop);
    } catch(ex) {
      console.error(ex);
    } finally {
      // "select-result" is firing twice from the Search widget for some reason
      setTimeout(() => {
        this.isQuerying = false;
      },1000)
    }
  }

  //@ts-ignore
  _indoorsOnPersonSelected = async (source: any, person: any, search: any, stop: any) => {
    //this.isQuerying = true;
    const anonymous = this.indoorsContext.user.isAnonymous();
    const layer = source && source.layer2D;
    const personAttributes = person && person.feature && person.feature.attributes;
    const knownas = this.getAttributeValue(personAttributes, "knownas");
    let lastKnownTrackingInfo;

    // See if the user has ongoing and/or upcoming reservations
    let upcomingReservations = [], pastReservation = [];
    if (!anonymous) {
      upcomingReservations = await this.tsUtil.tsFindUserReservations(person, "upcoming") || [];
      pastReservation = await this.tsUtil.tsFindUserReservations(person, "past") || [];
    }
    const noReservations = (upcomingReservations.length === 0) && (pastReservation.length === 0)
    const routableReservations = []
    pastReservation.forEach((reservation) => routableReservations.push(reservation));
    upcomingReservations.forEach((reservation) => routableReservations.push(reservation));

    const assignmentSelected = (assignment: any) => {
      // If the only location is a reservation, zoom to the unit but show the person info panel
      if (assignment.reservation && assignment.unit) {
        const { unit } = assignment;
        if (unit && unit.geometry && person && person.feature) {
          const people = this.indoorsContext.aiim.datasets && this.indoorsContext.aiim.datasets.people;
          const units = this.indoorsContext.aiim.datasets && this.indoorsContext.aiim.datasets.units;

          const unitsFloorField = units && units.layer2D && units.layer2D.floorInfo && units.layer2D.floorInfo.floorField;
          const levelId = unitsFloorField && this.getAttributeValue(unit.attributes, unitsFloorField);
          const peopleFloorField = people && people.layer2D && people.layer2D.floorInfo && people.layer2D.floorInfo.floorField;

          // Set the geometry and level id
          assignment.feature.geometry = unit.geometry;
          if (levelId && peopleFloorField) {
            assignment.feature.attributes[peopleFloorField] = levelId;
          }
        }
      }

      const levels = this.indoorsContext.aiim.datasets && this.indoorsContext.aiim.datasets.levels;
      if (levels) {
        levels.fixZ(source, assignment.feature);
      }

      //console.log("occupant.assignmentSelected",assignment)
      assignment.feature = this._makeStopResultFeature(assignment,stop);
      stop.result = assignment;
      stop.result.feature.attributes.Name = assignment.name;
      search.viewModel._set("selectedResult", stop.result);
      // @ts-ignore
      this._processStops();
      this.scheduleRender();
    };

    //@ts-ignore
    const selectLKL = async (features) => {
      if (!features || !features.length || !lastKnownTrackingInfo) {
        return;
      }
      //const trackingInfo = await this.tsUtil.tsQueryTrackingInfo(features);
      const trackingInfo = lastKnownTrackingInfo;
      const template = source.searchTemplate;
      const displayField = source.displayField;
      const name = this.tsUtil.getLayerFeatureText(features[0], template, displayField);
      const extent = null;
      const feature = trackingInfo && trackingInfo.feature;
      const target = feature;

      const searchResult = {
        extent,
        feature,
        target,
        name,
        sourceIndex: source.index
      };
      //console.log("occupant.selectLKL")
      assignmentSelected(searchResult);
    }

    const checkReservations = () => {
      //console.log("occupant.checkReservations")
      if (routableReservations.length === 1) {
        const { person, reservation, unit } = routableReservations[0];
        const location = person.feature;

        const template = source.searchTemplate;
        const displayField = source.displayField;
        const name = this.tsUtil.getLayerFeatureText(location, template, displayField);
        const extent = null;
        const feature = location;
        const target = feature;

        const searchResult = {
          extent,
          feature,
          target,
          name,
          sourceIndex: source.index,
          reservation,
          unit
        };

        //console.log("occupant.checkReservations.one")
        assignmentSelected(searchResult);
      } else {
        const { selectedResult } = search;
        const feature = selectedResult && selectedResult.feature;
        const geometry = feature && feature.geometry;

        if (!geometry || (geometry.x === 0 && geometry.y === 0 && geometry.z === 0)) {
          //console.log("occupant.checkReservations.tsShowMultipleAssignments")
          this.tsUtil.tsShowMultipleAssignments({
            assignments: [],
            personFeatures: [],
            title: knownas,
            upcomingReservations: [],
            pastReservation: [],
            noRoutableLocations: true
          });
        } else {
          //console.log("occupant.checkReservations._setStop")
          this._setStop(search, stop);
        }
      }
    }

    try {
      const results = await this.tsUtil.tsFindDuplicateRecords(layer, personAttributes);
      const features = results && results.features;
      const loneFeature = features && features.length === 1 && features[0];
      const lklFeature = this.tsUtil.tsGetLKL(features);
      let hasLKL = false;
      if (lklFeature) {
        const ti = await this.tsUtil.tsQueryTrackingInfo(features);
        if (ti && ti.feature) {
          lastKnownTrackingInfo = ti;
          hasLKL = true;
        }
      }

      if (loneFeature) {
        const hasAreaAssignment = this.tsUtil.hasAreaAssignment(loneFeature);
        const hasUnitAssignment = this.tsUtil.hasUnitAssignment(loneFeature);
        const hasAssignment = hasAreaAssignment || hasUnitAssignment;

        if (hasLKL && (hasAreaAssignment || !hasAssignment) && noReservations) {
          //console.log("occupant.loneLKL")
          await selectLKL([loneFeature]);
          return;
        }
        if (!hasLKL && hasUnitAssignment && noReservations) {
          //console.log("occupant.loneFeature._setStop")
          this._setStop(search, stop);
          return;
        }
      }

      const assignments = await this.tsUtil.tsGetAssignments(features);
      //console.log("occupant.tsGetAssignments",assignments)
      if (hasLKL && this.tsUtil.tsHasOnlyAreaAssignments(assignments) && noReservations) {
        //console.log("occupant.LKL-and-tsHasOnlyAreaAssignments")
        await selectLKL(features);
        return;
      }

      if (this.tsUtil.tsAssignmentsFound(assignments)) {
        // Check to see if there is 1 or more routable location
        const routableLocations = [];
        if (hasLKL) {
          //console.log("occupant.tsAssignmentsFound.using.lklFeature")
          routableLocations.push(lklFeature); // @todo ?
        }
        assignments.units.forEach((unit: any) => {
          routableLocations.push(unit);
        });
        pastReservation.forEach((reservation) => routableLocations.push(reservation));
        upcomingReservations.forEach((reservation) => routableLocations.push(reservation));

        if (routableLocations.length > 1) {
          //console.log("occupant.tsAssignmentsFound.tsShowMultipleAssignments")
          this.tsUtil.tsShowMultipleAssignments({
            assignments,
            personFeatures: features,
            title: knownas,
            directions: true,
            directionsCallback: assignmentSelected,
            pastReservation,
            upcomingReservations,
            hasLKL: hasLKL
          });
        } else if (routableLocations.length === 1) {
          if (hasLKL) {
            // console.log("occupant.tsAssignmentsFound.oneLKL")
            selectLKL(features);
          } else {
            const location = assignments.units[0].person;

            const template = source.searchTemplate;
            const displayField = source.displayField;
            const name = this.tsUtil.getLayerFeatureText(location, template, displayField);
            const extent = null;
            const feature = location;
            const target = feature;

            const searchResult = {
              extent,
              feature,
              target,
              name,
              sourceIndex: source.index
            };

            //console.log("occupant.tsAssignmentsFound.oneRoutable")
            assignmentSelected(searchResult);
          }
        } else {
          throw new Error("No routable locations within assignments");
        }
      } else {
        checkReservations();
      }
    } catch (e) {
      console.error(e);
      checkReservations();
    }
    //this.isQuerying = false;
  }

  // indoors specific
  getAttributeValue(attributes, name) {
    if (!attributes || !name) { return; }
    if (typeof name !== "string") { return; }
    if (attributes.hasOwnProperty(name)) { return attributes[name]; }
    let value, lc = name.toLowerCase();
    Object.keys(attributes).some(key => {
      if (key.toLowerCase() === lc) {
        value = attributes[key];
        return true;
      }
      return false;
    });
    return value;
  }

  // indoors specific
  _makeStopResultFeature(searchResult,stop) {
    let f = searchResult.feature;
    let geometry = f && f.geometry;
    if (f.attributes && f.attributes.bluedot === "y") {
      let graphic = this.indoorsContext.bluedot.graphic;
      if (graphic) {
        graphic = graphic.clone();
        graphic.attributes = {Name: f.attributes.Name};
        f = graphic;
        geometry = f && f.geometry;
      }
    }
    if (geometry && geometry.type === "polygon" && geometry.centroid) {
      geometry = geometry.centroid;
    }
    if (geometry && geometry.type === "point") {
      if (geometry.z === undefined && !geometry.hasZ) {
        if (typeof geometry.clone === "function") {
          geometry = geometry.clone();
        } else {
          geometry = JSON.parse(JSON.stringify(geometry));
        }
        geometry.z = 0;
        geometry.hasZ = true;
      }
    }
    const g = new this.indoorsContext.lib.esri.Graphic({
      attributes: {
        Name: searchResult.name
      },
      geometry: geometry
    })
    if (stop) {
      stop.name = searchResult.name;
      stop.geometry = geometry;
    }
    return g;
  }

  // indoors specific
  _setStop(search: any, stop: any) {
    // @ts-ignore
    //const searchResult = Object.assign({},search.selectedResult);
    const searchResult = search.selectedResult;
    this.tsUtil.fixSearchZ(search, searchResult);
    searchResult.feature = this._makeStopResultFeature(searchResult,stop);
    stop.result = searchResult;
    stop.result.feature.attributes.Name = searchResult.name;
    // @ts-ignore
    this._processStops();
    this.scheduleRender();
  }

  _setStopSymbols(): void {
    try {
      // @ts-ignore
      const stops = this.viewModel.layer.stops;
      if (stops) {
        // @ts-ignore
        const { first, last, middle, unlocated, waypoint, break: breakSymbol } = this.viewModel.layer.defaultSymbols.stops;
        stops.forEach((stop, index) => {
          switch (index) {
            case 0:
              // @ts-ignore
              stop.symbol = first;
              break;
            case stops.length - 1:
              // @ts-ignore
              stop.symbol = last;
              break;
            default:
              // @ts-ignore
              stop.symbol = middle;
              break;
          }
        });
      }
    } catch (ex) {
      console.error(ex);
    }
  }

}
